<!--
================================================
Vue pour gérer les users
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <app-layout-comp>
        <div slot="AppContent">
            <!-- Modale user ----------------------------------------------->
            <modal-user-management-comp></modal-user-management-comp>

            <!-- Entête de la page ----------------------------------------------->
            <div class="columns">
                <div class="column">

                    <!-- titre de la page ----------------------------------------------->
                    <div class="has-text-left appTitle is-hidden-mobile">
                        <h3 class=""><font-awesome-icon class="icon" :icon="['fas', 'users']" />{{$t('Équipe')}}</h3>
                        <p class="appSubTitle">{{$t('InviterEtGererLesMebmresDeVotreEquipe')}}</p>
                    </div>
                </div>

                <div class="column is-narrow">
                <!-- Bouton invit user ----------------------------------------------->
                    <a v-if="$auth.hasRole('ROLE_ADMIN')"
                       v-on:click="createUser()"
                       v-on:keyup.enter="createUser()"
                       v-bind:class="{'is-loading':newUserIsSubmiting}"
                       v-bind:disabled="newUserIsSubmiting" tabindex="0"
                       class="call2ActionBtn button has-text-white is-primary " id="submitNewUser" >
                        <font-awesome-icon :icon="['fas', 'plus-circle']" class="icon" />
                        <span>{{$t("InviterDesUtilisateurs")}}</span>
                    </a>

                </div>

            </div>

            <!-- List des users ----------------------------------------------->
            <user-list-comp></user-list-comp>

        </div>
    </app-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // @ is an alias to /src
    import AppLayoutComp from '@/components/AppLayoutComp.vue'
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import SpinnerLoaderComp from '@/components/SpinnerLoaderComp.vue';
    import UserListComp from '@/components/Team/UserListComp.vue';
    import ModalUserManagementComp from "../components/Team/ModalUserManagementComp";
    import {mapState} from "vuex";

    export default {
        name: 'UsersView',
        data: function () {
            return {

                // pour les composants où l'user est identifié ///////////////////////
                componentIsReady : false, // indique quand le composant est prêt à être afficher
                newUserIsSubmiting: false, // true si form création user en cours de soumission
                modeModalUserMgt: 'creation', // String le mode (creation/edition) dans lequel ouvrir la modalProjectManagement
                // =================================================================
            }
        },
        computed: {
            // computed props for store :
            ...mapState({
                user: state => state.user
                // organization: state => state.organization
            }),
        },
        components: {
            AppLayoutComp,SpinnerLoaderComp,
            UserListComp,ModalUserManagementComp
        },

        mixins: [VueMetaMixin, SentryMixin, InterceptorMixin],
        //==========================================================
        metaInfo(){
            return this.setMeta(this.$t("metaTitleUsersView"),this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {
            /**
             *  Ouvre la modal de création d'un user
             */
            createUser: function () {
                this.$root.$emit('show_modal_user_management','creation')
            },

          /**
             *  Affiche une notification indiquant que l'user doit être vérifié avant de pouvoir inviter des utilisateurs
             */
          warningInvitRequireVerif: function () {
            this.$store.commit('UpdateGlobalNotificationComp', {
              'isVisible': true,
              'color': 'is-warning',
              'message': this.$t('VousDevezVerifierVotreAdresseEmailAvantDInviter'),
              // 'duration': 1000
            });
            this.$mixpanel.track('Non verified user tried to invit', { "detail": "A non verified ROLE_OWNER user tried to invit people on his team. Warning message has been displayed"})
          },



        },
        created: function () {
        },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
    /*@import "../assets/css/globalVar.scss";*/
</style>
